<template>
  <div id="wrap">
    <app-header />
    <main></main>

    <app-footer />
    <scroll-to-top />
    <loading-anim
      v-bind:show="isLoading"
      :loaderColor="AppConst.LOADING.COLOR"
      :boxColor="AppConst.LOADING.BOXCOLOR"
    />
  </div>
</template>

<script>
import CmnSubMixin from "@mixins/cmnsub-mixin";
import HandleAjaxErrorMixin from "@mixins/handle-ajax-error-mixin";
import AppHeader from "@components/AppHeader";
import AppFooter from "@components/AppFooter";
import ScrollToTop from "@components/ScrollToTop";
import LoadingAnim from "@components/LoadingAnim";
import AppConst from "@utils/app-const";
import axios from "axios";

export default {
  name: "Entry",
  mixins: [CmnSubMixin, HandleAjaxErrorMixin],
  components: {
    AppHeader,
    AppFooter,
    ScrollToTop,
    LoadingAnim,
  },
  data() {
    return {
      tokenInfo: null,
      isLoading: true,
    };
  },
  mounted() {
    // CSRFトークン取得
    axios.get(process.env.VUE_APP_API_BASE + AppConst.API.URL.CSRF).then(() => {
      axios
        .get(
          process.env.VUE_APP_API_BASE +
            AppConst.API.URL.LOGENTRYURL +
            "/" +
            this.$route.params.token
        )
        .then((response) => {
          this.isLoading = false;
          var res = response.data;
          if (res.res_cd == AppConst.RET_CD.OK) {
            // 申込フォームに遷移
            // console.log("redirect to form");
            this.$router.push({
              name: AppConst.ROUTENM.FORM,
              params: { token: this.$route.params.token },
            });
          } else {
            switch (res.res_errcd) {
              case AppConst.API_ERRCD.TAU_EXPIRED: {
                // 期限切れエラー
                this.$router.push({ name: AppConst.ROUTENM.EXPIRED });
                return;
              }
              case AppConst.API_ERRCD.TAU_APPLIED: {
                // 申込済み
                this.$router.push({
                  name: AppConst.ROUTENM.ERROR,
                  params: { errCd: AppConst.ERRSCR_ERRCD.TAU_COMPLETED },
                });
                return;
              }
              case AppConst.API_ERRCD.UPDERR: {
                // データ更新エラー
                this.alert(res.errmsg, "情報", "閉じる");
                return;
              }
            }
          }
        })
        .catch((reason) => {
          // エラー
          this.isLoading = false;
          if (!this.handleAjaxError(reason.response, false, null)) {
            this.showRetry();
          }
        });
    });
  },
};
</script>
